import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'about',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'about',
				),
			store,
			'ABOUT',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/About/index.js